module.exports = __webpack_public_path__ + "img/pr-3.e06355da.png";